export default [
  // 题库管理
  // {
  //   path: '/problemBack',
  //   name: 'problem',
  //   meta: { title: '题目列表' },
  //   component: () => import('@/views/pages/problemBack/index')
  // },
  // {
  //   path: '/problemBack/:errorBookID/create',
  //   name: 'create',
  //   meta: { title: '创建题目' },
  //   component: () => import('@/views/pages/courseBack/chapter/add')
  //   // component: () => import('@/views/pages/problemBack/index')
  // },
  // {
  //   path: '/problemBack/:errorBookID/:problemID',
  //   name: 'problem',
  //   meta: { title: '编辑题目' },
  //   component: () => import('@/views/pages/problemBack/index')
  // },
  {
    path: '/problemBack/',
    component: () => import('@/views/pages/problemBack/index'),
    redirect: '/problemBack/',
    children: [
      {
        path: 'create',
        name: 'create',
        meta: { title: '创建题目' },
        component: () => import('@/views/pages/problemBack/code.vue')
      },
      {
        path: '',
        name: 'problemBack',
        meta: { title: "题目管理" },
        component: () => import('@/views/pages/problemBack/empty')
      },
      {
        path: ':problemID',
        name: 'problemBackProblem',
        meta: { title: "题目管理" },
        component: () => import('@/views/pages/problemBack/code.vue')
      }
    ]
  }
]
